export const environment = {
  production: false,
  appEnv: 'dev' as const,
  providerSearchUrl: 'https://medhub.facilinformatica.com.br/provider-search',
  newMedicalNetworkBaseUrl: 'https://api.medhub.facilinformatica.com.br',
  apiPrestadoresBaseUrl: 'https://homologacao.vivest.com.br/apis/api-prestadores/v1/ConsultaRedeCredenciada',
  ocpApiPrestadores: '',
  googleMapsApiKey: '',
};
